import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-check-circle-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M8.00016 1.33337C4.32683 1.33337 1.3335 4.32671 1.3335 8.00004C1.3335 11.6734 4.32683 14.6667 8.00016 14.6667C11.6735 14.6667 14.6668 11.6734 14.6668 8.00004C14.6668 4.32671 11.6735 1.33337 8.00016 1.33337ZM11.1868 6.46671L7.40683 10.2467C7.3135 10.34 7.18683 10.3934 7.0535 10.3934C6.92016 10.3934 6.7935 10.34 6.70016 10.2467L4.8135 8.36004C4.62016 8.16671 4.62016 7.84671 4.8135 7.65337C5.00683 7.46004 5.32683 7.46004 5.52016 7.65337L7.0535 9.18671L10.4802 5.76004C10.6735 5.56671 10.9935 5.56671 11.1868 5.76004C11.3802 5.95337 11.3802 6.26671 11.1868 6.46671Z"
        [attr.fill]="color()" />
    </svg>
  `,
})
export class CheckCircleIconComponent extends BaseIconComponent {
  override width = input<string>('16');
  override height = input<string>('16');
  override viewBox = input<string>('0 0 16 16');
  override fill = input<string>('none');
  override color = input<string>('currentColor');
}
